import { format } from "date-fns";

// eslint-disable-next-line no-extend-native
Date.prototype.toJSON = function () {
  const validDate =  this.getTime() === this.getTime();
  return validDate ? format(this, "yyyy-MM-dd'T'HH:mm:ss"):"";
};
